<template>
    <div class="header-continer">
        <div class="menu-content">
            <div>
                <HamburgerMenu @all-dishes="handleShowAllDishes" @new-dishes="handleShowAddNewProduct"
                    @new-category="handleShowAddNewCategory" @all-category="handleShowAllCategories"
                    @daily-menu="hadleShowDailyMenuAdmin" />
            </div>
        </div>
        <Header></Header>
    </div>
    <div v-if="showAllDishes" class="card-admin-continer">
        <NavBar @update:selectedCategory="handleCategoryUpdate" />
        <div class="allProduct-title">
            <h1>{{ selectedCategory }}</h1>
        </div>
        <CardProductAdmin v-for="(product) in filteredProducts" :key="product.id" :product="product"
            @refresh-products="loadData" />
    </div>
    <div class="loading-container">
        <LoadingAnimation v-if="loading"></LoadingAnimation>
    </div>

    <div v-if="showNewProduct" class="custom-admin-container">
        <NewProductCard @new-product-created="newProductAdded" />
    </div>

    <div v-if="showAddNewCategory" class="custom-admin-container">
        <NewCategoryCard @new-category-created="handleShowAllCategories" />
    </div>

    <div v-if="showAllCategories" class="card-admin-continer">
        <div class="allProduct-title">
            <h1>Tutte le categorie</h1>
        </div>
        <CardCategoryAdmin v-for="(category, index) in categories" :key="index" :category="category"
            @refresh-category="handleShowAllCategories" />
    </div>

    <div v-if="showDailyMenuAdmin" class="custom-admin-container">
        <div class="allProduct-title">
            <h1>Menu del giorno</h1>
        </div>
        <DailyMenuAdmin @updated-daily-menu="handleDailyMenuUpdated"></DailyMenuAdmin>
    </div>
</template>

<script>
import { fetchAllDishes } from '@/api/DishesAPI'
import { fetchAllCategories } from '@/api/CategoryAPI';
import Header from '@/components/homepage/Header.vue'
import LoadingAnimation from '@/components/generic/LoadingAnimation.vue'
import HamburgerMenu from '@/components/adminpage/HamburgerMenu'
import CardProductAdmin from '@/components/adminpage/CardProductAdmin.vue'
import NewProductCard from '@/components/adminpage/NewProductCard.vue'
import CardCategoryAdmin from '@/components/adminpage/CardCategoryAdmin'
import NewCategoryCard from '@/components/adminpage/NewCategoryCard.vue'
import DailyMenuAdmin from '@/components/adminpage/DailyMenuAdmin.vue'
import NavBar from '@/components/menupage/NavBar.vue';

export default {
    components: {
        Header,
        LoadingAnimation,
        HamburgerMenu,
        CardProductAdmin,
        NewProductCard,
        CardCategoryAdmin,
        NewCategoryCard,
        DailyMenuAdmin,
        NavBar,
    },
    data() {
        return {
            products: [],
            filteredProducts: [],
            categories: [],
            selectedCategory: 'Menu',
            loading: false,
            selelectedProduct: null,
            showAllDishes: true,
            showNewProduct: false,
            showAllCategories: false,
            showAddNewCategory: false,
            showDailyMenuAdmin: false,
            forceReloadCardProduct: false,
        }
    },
    async mounted() {
        this.loadData();
    },

    methods: {
        async loadData() {
            this.loading = true;
            this.products = await fetchAllDishes();
            this.filteredProducts = this.products;
            this.loading = false;
        },
        async newProductAdded() {
            this.showNewProduct = false;
            this.loading = true;
            this.products = [];
            await this.loadData();
            this.showAllDishes = true;
        },
        handleShowAddNewProduct() {
            this.showAllDishes = false;
            this.showNewProduct = true;
            this.showAddNewCategory = false;
            this.showAllCategories = false;
            this.showDailyMenuAdmin = false;
        },
        handleShowAllDishes() {
            this.showAllDishes = true;
            this.showNewProduct = false;
            this.showAddNewCategory = false;
            this.showAllCategories = false;
            this.showDailyMenuAdmin = false;
        },
        handleShowAddNewCategory() {
            this.showAllDishes = false;
            this.showNewProduct = false;
            this.showAddNewCategory = true;
            this.showAllCategories = false;
            this.showDailyMenuAdmin = false;
        },
        hadleShowDailyMenuAdmin() {
            this.showAllDishes = false;
            this.showNewProduct = false;
            this.showAddNewCategory = false;
            this.showAllCategories = false;
            this.showDailyMenuAdmin = true;
        },
        async handleShowAllCategories() {
            this.loading = true;
            this.categories = [];
            this.categories = await fetchAllCategories();
            this.showAllDishes = false;
            this.showNewProduct = false;
            this.showAddNewCategory = false;
            this.showAllCategories = true;
            this.showDailyMenuAdmin = false;
            this.loading = false
        },
        handleCategoryUpdate(category) {
            this.selectedCategory = category;
            if (category === 'Menu') {
                this.filteredProducts = this.products;
            } else {
                this.filteredProducts = this.products.filter(product =>
                    product.category.toLowerCase() === category.toLowerCase()
                );
            }
            this.forceReloadCardProduct = !this.forceReloadCardProduct;
        },
        async handleDailyMenuUpdated() {
            window.scrollTo(0, 0);
            this.loading = true;
            await new Promise(resolve => setTimeout(resolve, 2000));
            this.loading = false;
        }
    }
}
</script>

<style>
.card-admin-continer {
    background-color: var(--background-color);
    position: relative;
    top: 30px;
    min-height: 100vh;
    padding-top: 30px;
}

.add-product {
    position: fixed;
    top: 8px;
    right: 10px;
    color: var(--text-color);
    font-size: 40px;
    z-index: 1000;
    float: right;
}

.menu-content {
    font-family: "Anta", sans-serif;
    position: absolute;
    top: 55px;
    left: 0;
    z-index: 1000;
}

.custom-admin-container {
    min-height: 100vh;
    background-color: var(--background-color);
    padding-top: 40px;
}

#arrow-admin-page {
    color: #FFFFFF;
    position: fixed;
    top: 8px;
    left: 8px;
    z-index: 400;
    font-size: 40px;
}

.allProduct-title {
    color: var(--text-color);
    background-color: var(--accent-color);
    text-align: center;
    margin: 20px;
    margin-bottom: 20px;
    margin-top: 40px;
    border-radius: 25px;
    border: solid 2px;
    border-color: var(--border-color);
    box-shadow: var(--custom-box-shadow);
}

.allProduct-title h1 {
    padding: 10px;

}
</style>
